import * as yup from 'yup';

export const variantValidationSchema = formatMessage =>
  yup.object({
    languageCode: yup
      .string()
      .required(
        formatMessage({
          id: 'CHOOSE_A_LANGUAGE',
          defaultMessage: 'Choose a language',
        }),
      )
      .matches(
        /^[a-z]{2}(-[a-z]{2})?$/,
        formatMessage({
          id: 'CHOOSE_A_LANGUAGE',
          defaultMessage: 'Choose a language',
        }),
      ),
    title: yup
      .string()
      .trim()
      .max(
        256,
        formatMessage({
          id: 'DOCUMENT_MANAGEMENT_TITLE_TOO_LONG',
          defaultMessage: 'Use a title of 256 characters or fewer',
        }),
      )
      .required(
        formatMessage({
          id: 'ENTER_A_TITLE',
          defaultMessage: 'Enter a title',
        }),
      ),
    description: yup.string().nullable(),
    // A variant needs a PDF or a video: a new file, or one already uploaded.
    pdfFile: yup
      .mixed()
      .nullable()
      .test(
        'file',
        formatMessage({
          id: 'CHOOSE_A_PDF_OR_A_VIDEO',
          defaultMessage: 'Choose a PDF or a video',
        }),
        function fileRequired() {
          const { pdfFile, videoFile, pdf, video } = this.parent;
          return Boolean(
            pdfFile || videoFile || pdf?.fileName || video?.fileName,
          );
        },
      ),
  });
export const metadataValidationSchema = formatMessage =>
  yup.object({
    appVersion: yup
      .string()
      .required(
        formatMessage({
          id: 'ENTER_AN_APP_VERSION',
          defaultMessage: 'Enter an app version',
        }),
      )
      .matches(
        /^\d+(\.\d+){0,2}$/,
        formatMessage({
          id: 'USE_AN_APP_VERSION_SUCH_AS_4360',
          defaultMessage: 'Use an app version such as 4.36.0',
        }),
      ),
    category: yup
      .string()
      .trim()
      .required(
        formatMessage({
          id: 'ENTER_A_CATEGORY',
          defaultMessage: 'Enter a category',
        }),
      ),
    companyType: yup
      .string()
      .nullable()
      .oneOf(['', null, 'SERVICE_ADMINISTRATOR', 'SERVICE_PROVIDER']),
    visibility: yup
      .string()
      .oneOf(['PUBLIC', 'PRIVATE'])
      .required(
        formatMessage({
          id: 'CHOOSE_A_VISIBILITY',
          defaultMessage: 'Choose a visibility',
        }),
      ),
    status: yup
      .string()
      .oneOf(['ACTIVE', 'INACTIVE'])
      .required(
        formatMessage({
          id: 'CHOOSE_A_STATUS',
          defaultMessage: 'Choose a status',
        }),
      ),
  });
export const createValidationSchema = formatMessage =>
  metadataValidationSchema(formatMessage).concat(
    variantValidationSchema(formatMessage),
  );
